module.exports = __webpack_public_path__ + "img/thumb_image10.23242b89.jpg";